import { render, staticRenderFns } from "./PackingListIndex.vue?vue&type=template&id=36c4fe40&"
import script from "./PackingListIndex.vue?vue&type=script&lang=js&"
export * from "./PackingListIndex.vue?vue&type=script&lang=js&"
import style0 from "./PackingListIndex.vue?vue&type=style&index=0&id=36c4fe40&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports